import { ApiNotificacao } from "./api-notificacao";
import { Apontamento } from "./apontamento";

export class ApontamentoResult {
    success: boolean;
    data: Apontamento;
    notifications: ApiNotificacao[];
    errors: string[];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
